import logger from 'technical/logger';

export async function downloadFile(url: string, name?: string) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobURL = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobURL;
    a.download = name ?? 'defaultFileName.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (e) {
    return logger.error(e);
  }
}
